// extracted by mini-css-extract-plugin
export var search_form = "search_form-module--search_form--ebdb1";